const alias = 'OTHER_TEST_SCORE';

export const GET_OTHER_TEST_SCORES_REQUEST = `GET_${alias}S_REQUEST`;
export const GET_OTHER_TEST_SCORES_SUCCESS = `GET_${alias}S_SUCCESS`;
export const GET_OTHER_TEST_SCORES_FAILURE = `GET_${alias}S_FAILURE`;
export const GET_OTHER_TEST_SCORES_CLEAR = `GET_${alias}S_CLEAR`;

export const ADD_OTHER_TEST_SCORES_REQUEST = `ADD_${alias}_REQUEST`;
export const ADD_OTHER_TEST_SCORES_SUCCESS = `ADD_${alias}_SUCCESS`;
export const ADD_OTHER_TEST_SCORES_FAILURE = `ADD_${alias}_FAILURE`;

export const UPDATE_OTHER_TEST_SCORE_REQUEST = `UPDATE_${alias}_REQUEST`;
export const UPDATE_OTHER_TEST_SCORE_SUCCESS = `UPDATE_${alias}_SUCCESS`;
export const UPDATE_OTHER_TEST_SCORE_FAILURE = `UPDATE_${alias}_FAILURE`;

export const DELETE_OTHER_TEST_SCORE_REQUEST = `DELETE_${alias}_REQUEST`;
export const DELETE_OTHER_TEST_SCORE_SUCCESS = `DELETE_${alias}_SUCCESS`;
export const DELETE_OTHER_TEST_SCORE_FAILURE = `DELETE_${alias}_FAILURE`;
